module.exports = __webpack_public_path__ + "static/img/3bg_5.a71f53b.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/3bg_5.png
// module id = 698
// module chunks = 1